import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import * as S from './DesktopFilters.styles';
import { DesktopFilterSelectOptionProps } from './DesktopFilterSelectOption.types';
import {
  getDesktopFilterSelectOptionHref,
  preserveUserIdInDesktopFilterQuery,
} from './DesktopFilterSelectOption.helpers';

export const DesktopFilterSelectOption = ({
  dataTestId,
  label,
  hrefParams,
  isSelected,
  onClick,
  onNavigateHref,
}: DesktopFilterSelectOptionProps) => {
  const router = useRouter();
  const href = getDesktopFilterSelectOptionHref(hrefParams);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      onClick?.();

      if (onNavigateHref) {
        e.preventDefault();
        onNavigateHref(href);
        return;
      }

      if (preserveUserIdInDesktopFilterQuery(router.asPath)) {
        e.preventDefault();
        router.push(href, undefined, { scroll: false, shallow: true });
      }
    },
    [href, onClick, onNavigateHref, router]
  );

  return (
    <S.LinkOption
      key={label}
      dataTestId={dataTestId}
      href={href}
      scroll={false}
      $isActive={isSelected}
      onClick={handleClick}
    >
      <S.RadioButton $isActive={isSelected} />
      <S.LinkOptionText>{label}</S.LinkOptionText>
    </S.LinkOption>
  );
};
